import React from "react";

import { Navbar } from "../../../components";
import { JustEatTakeaway } from "./JustEatTakeAway";

const JustEatTakeawayProject = () => {
  return (
    <div className="app">
      <Navbar />
      <JustEatTakeaway />
    </div>
  );
};

export default JustEatTakeawayProject;
